import { get } from 'lodash';
import { schema } from 'normalizr';

import { PayloadApiRequest } from '../actions/sagaApi';

import appointmentsResource from './appointmentsResource';
import appointmentTypesResource from './appointmentTypesResource';
import createResource from './createResource';
import facilitiesResource from './facilitiesResource';
import offersResourceConfig from './offersResourceConfig';
import patientsResource from './patientsResource';
import providersResource from './providersResource';
import { EntityID, Offer, Waitlist } from './types';
import usersResource from './usersResource';

// Re-creating offersResource due to circular dependency on `offer.waitlists`
const offersResource = createResource<Offer>(offersResourceConfig);

const waitlistsResource = createResource<Waitlist>({
  key: 'waitlists',
  url: '/waitlists',
  fetchPageUrl: '/waitlists/crudList',
  hasFetchBulkSupport: true,
  lookups: {
    approvedBy: usersResource,
    createdFromAppointment: appointmentsResource,
    declinedBy: usersResource,
    facility: facilitiesResource,
    futureAppointment: appointmentsResource,
    patient: patientsResource,
    user: usersResource,
    offer: offersResource,
    declinedOffer: offersResource,
    provider: {
      ...providersResource,
      schema: new schema.Array(providersResource.schema),
    },
    appointmentType: {
      ...appointmentTypesResource,
      schema: new schema.Array(appointmentTypesResource.schema),
    },
  },
  processStrategy: (data) => ({
    ...data,
    $toString: `[${data.status}] ${data.$toString}`,
  }),
});

const customActions = {
  updateWaitlistStatus: (
    id: EntityID,
    params: {
      facilityid: EntityID;
      offerid: EntityID;
    },
    status: 'confirmOffer' | 'declineOffer' | 'cancelOffer',
    payload?: PayloadApiRequest<Waitlist>,
  ) =>
    waitlistsResource.request({
      url: `${waitlistsResource.url}/${status}/${id}`,
      params,
      ...payload,
      meta: {
        schema: waitlistsResource.schema,
        messageError: 'There was a problem updating the offer. Please try again',
        ...get(payload, 'meta'),
      },
    }),
};

export default {
  ...waitlistsResource,
  ...customActions,
};
